import { useState, useEffect } from 'react'
import { track } from '@vercel/analytics'

const DELAY_MS = 10000
const isDesktop = () => window.innerWidth >= 1280

export default function NewsletterPopup({ bannerDismissed, onVisibleChange }) {
  const [visible, setVisible] = useState(false)

  // On desktop: start timer immediately on mount regardless of banner state
  useEffect(() => {
    if (!isDesktop()) return
    const timer = setTimeout(() => setVisible(true), DELAY_MS)
    return () => clearTimeout(timer)
  }, [])

  // On mobile/tablet: wait for banner to be dismissed first
  useEffect(() => {
    if (isDesktop()) return
    if (!bannerDismissed) return
    const timer = setTimeout(() => setVisible(true), DELAY_MS)
    return () => clearTimeout(timer)
  }, [bannerDismissed])

  useEffect(() => {
    onVisibleChange(visible)
  }, [visible])

  if (!visible) return null

  const hide = () => setVisible(false)

  return (
    <div className="newsletter-overlay" onClick={() => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'button_click', poi_label: 'Newsletter - Close' })
      track('button_click', { poi_label: 'Newsletter - Close' })
      hide()
    }}>
      <div className="newsletter-popup" onClick={e => e.stopPropagation()}>
        <button
          className="newsletter-popup-close"
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: 'button_click', poi_label: 'Newsletter - Close' })
            track('button_click', { poi_label: 'Newsletter - Close' })
            hide()
          }}
          aria-label="Close"
        >
          X
        </button>
        <h2 className="newsletter-popup-title">
          Looking forward to the first UK launch test this summer?
        </h2>
        <p className="newsletter-popup-body">
          Sign up to the SaxaVord newsletter to stay updated.
        </p>
        <a
          href="http://eepurl.com/ifM-Vj"
          target="_blank"
          rel="noopener noreferrer"
          className="newsletter-popup-button"
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: 'button_click', poi_label: 'Newsletter - Sign Up' })
            track('button_click', { poi_label: 'Newsletter - Sign Up' })
            hide()
          }}
        >
          SIGN UP
        </a>
      </div>
    </div>
  )
}
